<template>
  <v-dialog
      v-model="show"
      :max-width="'450px'"
      persistent
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Erschwerniszulagen wählen</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-row style="margin: 0">
              <v-text-field
                  v-model="search_ez"
                  prepend-icon="mdi-magnify"
                  label="Suchen"
                  single-line
                  hide-details
                  clearable
              ></v-text-field>
            </v-row>
            <v-list                 style="max-height: 45vh; min-height: 45vh; overflow-y: auto"
            >
              <v-list-item-group
                  v-model="selectedEzs"
                  multiple
                  color="indigo"
              >
                  <v-list-item
                      v-for="(item, i) in filteredEzs"
                      :key="item.access"
                      :value="item.access"
                      :style="{
                        'border-bottom': 'rgba(128,128,128,0.25) thin solid',
                      }"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            v-on:click.stop="show = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            :disabled="selectedEzs.length === 0"
            v-on:click.stop="sendResult"
        >
          Auswählen
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
        v-model="showDuration"
        :max-width="'500px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Dauer wählen</span>
        </v-card-title>
        <v-card-text>
          <v-time-picker
              v-model="currentDuration"
              format="24hr"
              :max="duration"
              landscape
          ></v-time-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="cancelDuration"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="timeRegex.test(currentDuration) === false"
              v-on:click.stop="saveDuration"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-dialog>

</template>

<script>


export default {
  name: "SelectEzsDialog",
  props: {
    ezs: {
      type: Array,
      default: () => []
    },
    duration: {
      type: String,
      default: () => '04:30'
    }
  },
  computed: {
    filteredEzs() {
      let res =  this.ezs;
      if (this.search_ez && this.search_ez.length > 0) {
        const search = this.search_ez.toLowerCase();
        res = res.filter(ez => ez.name.toLowerCase().includes(search));
      }
      return res;
    },
  },
  watch: {
    selectedEzs(newVal, oldVal) {
      // check if we have deletion or addition
      if (newVal.length < oldVal.length) {
        // deletion
        let deleted = oldVal.filter(x => !newVal.includes(x));
        for (let i = 0; i < deleted.length; i++) {
          delete this.durations[deleted[i]];
        }
      } else {
        // addition
        let added = newVal.filter(x => !oldVal.includes(x));
        for (let i = 0; i < added.length; i++) {
          this.currentAddition = added[i];
          this.currentDuration = this.duration;
          this.durations[this.currentAddition] = this.currentDuration;
          //this.showDuration = true;
          break;
        }
      }
    }
  },

  data: () => ({
    selectedEzs: [],
    show: false,
    search_ez: '',
    currentAddition: null,
    showDuration: false,
    currentDuration: '',
    durations: {},
    timeRegex: /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/,
  }),
  methods: {
    openDialog() {
      this.selectedEzs = [];
      this.durations = {};
      this.show = true;
    },
    saveDuration() {
      this.durations[this.currentAddition] = this.currentDuration;
      this.showDuration = false;
    },
    cancelDuration() {
      // remove from selectedArtis
      let index = this.selectedEzs.findIndex(a => a === this.currentAddition);
      if (index !== -1) {
        this.selectedEzs.splice(index, 1);
      }
      this.showDuration = false;
    },
    sendResult() {
      this.show = false;
      let result = [];
      for (let i = 0; i < this.selectedEzs.length; i++) {
        let access = this.selectedEzs[i];
        let duration = this.durations[access];
        result.push({
          access: access,
          duration: duration
        });
      }
      this.$emit('save', result);
    }
  }



}
</script>

<style scoped>
::v-deep .v-list-item__content {
  padding: 0px 0;
}

::v-deep .v-list-item {
  min-height: 34px;
}

::v-deep .v-subheader {
  height: 24px;
  font-weight: 500;
}

::v-deep .v-divider {
  margin-bottom: 6px;
  margin-top: 6px;
}

</style>
